﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251025   
    This script contains s used for data validation
*/
'use strict';

const cleanAndPasteText = (e) => {
    // cancel paste
    e.preventDefault();

    // get text representation of clipboard
    const text = (e.originalEvent ?? e).clipboardData.getData('text/plain');

    // insert text manually
    document.execCommand("insertHTML", false, text);
};

const cleanText = (str) =>
    str.replace(/<[^>]+>/g, '');
    
const decodeHtml = str =>
    str.replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec));

const encodeHtml = str => 
    [...str].map(ch => `&#${ch.charCodeAt()};`).join('');

//const formatMoney = (params) => {
//    let n = params.number,
//        digits = isNaN(params.digits = Math.abs(params.digits)) ? 2 : params.digits, 
//        decimalSign = params.decimalSign === undefined ? "." : params.decimalSign, 
//        thousandSign = params.thousandSign === undefined ? "," : params.thousandSign, 
//        s = n < 0 ? "-" : "", 
//        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(digits))), 
//        j = (j = i.length) > 3 ? j % 3 : 0;
//    return s + (j ? i.substr(0, j) + thousandSign : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandSign) + (digits ? decimalSign + Math.abs(n - i).toFixed(digits).slice(2) : "");
//};

const formatMoney = ({ number, digits = 2, decimalSign = ".", thousandSign = "," }) => {
    const n = Math.abs(Number(number) || 0);
    const s = number < 0 ? "-" : "";
    const fixed = n.toFixed(Math.abs(digits));
    const [intPart, decPart] = fixed.split(".");
    const i = intPart;
    const j = i.length > 3 ? i.length % 3 : 0;
    const intFormatted = (j ? i.slice(0, j) + thousandSign : "") +
        i.slice(j).replace(/(\d{3})(?=\d)/g, `$1${thousandSign}`);
    return s + intFormatted + (digits ? decimalSign + decPart : "");
};

const formatTimeStampToDateTime = ({ timeStamp, showDateOnly }) => {
    const dt = timeStamp === undefined
        ? new Date()
        : new Date(timeStamp * 1000);

    const months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dateStr = `${months_arr[dt.getMonth()]} ${dt.getDate()} ${dt.getFullYear()}`;

    return showDateOnly
        ? dateStr
        : `${dateStr} ${dt.getHours()}:${dt.getMinutes().toString().padStart(2, '0')}:${dt.getSeconds().toString().padStart(2, '0')}`;
};

const getHtmlDateInputVal = ({ date, datestr }) => {
    // Formats a date so it can be used in an HTML5 input control of type date
    let d = date === undefined ? new Date(datestr) : date;
    d = new Date(d.getTime() + Math.abs(d.getTimezoneOffset() * 60000)); // adjust for timezone

    const day = String(d.getDate()).padStart(2, '0');
    const mo = String(d.getMonth() + 1).padStart(2, '0');

    return `${d.getFullYear()}-${mo}-${day}`;
};

const getUTCDate = (params = {}) => {
    const dt = params.dt ?? new Date();
    return new Date(
        `${dt.getUTCMonth() + 1}/${dt.getUTCDate()}/${dt.getUTCFullYear()} ` +
        `${dt.getUTCHours()}:${dt.getUTCMinutes()}:${dt.getUTCSeconds()}`
    );
};

export {
    cleanAndPasteText, cleanText,
    decodeHtml, encodeHtml,
    formatMoney, formatTimeStampToDateTime,
    getHtmlDateInputVal, getUTCDate
}; 
